<template>
  <main class="visit-page">
    <section class="visit-shell">
      <app-header
        heading="Add Project"
        :isFormPage="true"
        @logout="logout"
        :subHeading="
          accessType == 'CREATE'
            ? 'Record a new dealer project lead.'
            : 'View and update dealer project lead details.'
        "
        @show-drawer="showDrawer"
      />
      <div v-if="userHaveRights">
        <div v-if="accessType !== 'readOnly'" class="progress-steps">
          <div
            v-for="(item, index) in steps"
            :key="index"
            class="progress-step"
            :class="{
              active: activeStep >= index,
              current: activeStep === index,
            }"
          >
            <span>{{ index + 1 }}</span
            ><small>{{ item }}</small>
          </div>
        </div>

        <q-form ref="projectForm" @submit.prevent="nextStep">
          <section v-if="activeStep === 0" class="form-card">
            <div class="section-heading">
              <span class="section-icon"
                ><q-icon size="md" name="event_note"
              /></span>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <h2 class="no-padding no-margin">Project details</h2>
                <!-- <p class="no-padding no-margin">Core information for this market visit.</p> -->
              </div>
            </div>
            <div class="form-grid">
              <!-- <q-input
                            v-model.trim="form.dealerName"
                            :disable="false"
                            outlined
                            dense
                            label="Dealer Name *"
                            :rules="[required]"
                            class="formField"
                            hide-bottom-space
                        /> -->
              <template v-if="$q.screen.gt.md">
                <custom-select
                  :value="form.dealerName"
                  model="dealerName"
                  :options="dealers.map((e) => e.name)"
                  :key="dealers?.length"
                  @change="handleSelect"
                  outlined
                  dense
                  label="Dealer *"
                  :rules="[required]"
                  class="formField full-width"
                  :disable="accessType != 'CREATE' || dealers.length == 1"
                />
              </template>
              <advance-search-select
                v-else
                :value="form.dealerName"
                model="dealerName"
                :options="dealers.map((e) => e.name)"
                :key="dealers?.length"
                @change="handleSelect"
                outlined
                dense
                label="Dealer *"
                :rules="[required]"
                class="formField full-width"
                :disable="accessType != 'CREATE' || dealers.length == 1"
              />
              <q-input
                v-model="form.projectName"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Project Name *"
                class="formField"
                type="text"
                stack-label
                :rules="[required]"
              />
              <q-input
                v-model="form.location"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Location *"
                class="formField"
                stack-label
                :rules="[required]"
              />
              <!-- <q-input v-model.trim="form.samName" outlined dense label="SAM Name *" :rules="[required]" /> -->
              <template v-if="$q.screen.gt.md">
                <custom-select
                  :value="form.projectCity"
                  model="projectCity"
                  :options="projectCities?.map((e) => e.cityName)"
                  :key="projectCities?.length"
                  outlined
                  dense
                  label="Project City *"
                  :rules="[required]"
                  @change="handleSelect"
                  :disable="accessType === 'readOnly'"
                  class="formField"
                  ref="Select"
                />
              </template>
              <advance-search-select
                v-else
                :value="form.projectCity"
                model="projectCity"
                :options="projectCities?.map((e) => e.cityName)"
                :key="projectCities?.length"
                outlined
                dense
                label="Project City *"
                :rules="[required]"
                @change="handleSelect"
                :disable="accessType === 'readOnly'"
                class="formField"
              />
              <template v-if="$q.screen.gt.md">
                <custom-select
                  :value="form.projectStage"
                  model="projectStage"
                  :options="projectStages.map((s) => s.stageName)"
                  outlined
                  dense
                  :key="projectStages?.length"
                  label="Project Stage *"
                  @change="handleSelect"
                  :disable="accessType === 'readOnly'"
                  :rules="[required]"
                  class="formField"
                />
              </template>
              <advance-search-select
                v-else
                :value="form.projectStage"
                model="projectStage"
                :options="projectStages.map((s) => s.stageName)"
                outlined
                dense
                :key="projectStages?.length"
                label="Project Stage *"
                @change="handleSelect"
                :disable="accessType === 'readOnly'"
                :rules="[required]"
                class="formField"
              />

              <q-input
                v-model="form.updateDate"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Update Date *"
                hide-bottom-space
                class="formField"
                type="date"
                stack-label
                :rules="[required]"
              />
              <q-input
                v-model="form.dealerRepName"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Dealer Rep. Name *"
                class="formField"
                type="text"
                stack-label
                :rules="[required]"
              />
              <q-input
                v-model="form.dateOfFirstVisit"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Date of First Visit"
                hide-bottom-space
                class="formField"
                type="date"
                stack-label
              />
              <q-input
                v-model="form.qouteSubmissionDate"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Qoute submission Date"
                hide-bottom-space
                class="formField"
                type="date"
                stack-label
              />
              <q-input
                v-model="formattedTotalQuoteValue"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                label="Total Quote Value *"
                hide-bottom-space
                class="formField"
                type="numer"
                stack-label
              />
              <template v-if="accessType === 'CREATE'">
                <template v-if="$q.screen.gt.md">
                  <custom-select
                    :value="form.productQoute"
                    model="productQoute"
                    ref="productQoute"
                    :options="
                      products?.map((e) => e.skuCode + '-' + e.prodDescription)
                    "
                    @change="handleSelect"
                    :key="products?.length"
                    outlined
                    dense
                    label="Product Qouted *"
                    class="formField"
                    :disable="accessType === 'readOnly'"
                    :isOptionSlot="true"
                  />
                </template>
                <advance-search-select
                  v-else
                  :value="form.productQoute"
                  model="productQoute"
                  ref="productQoute"
                  :options="
                    products?.map((e) => e.skuCode + '-' + e.prodDescription)
                  "
                  @change="handleSelect"
                  :key="products?.length"
                  outlined
                  dense
                  label="Product Qouted *"
                  class="formField"
                  :disable="accessType === 'readOnly'"
                />
                <div></div>
                <div class="">
                  <q-chip
                    class=""
                    v-for="(code, i) in itemsCodesList"
                    :key="i"
                    removable
                    dense
                    @remove="itemsCodesList.splice(i, 1)"
                  >
                    <span class="code-class">{{ code }}</span>
                  </q-chip>
                </div>
                <q-input
                  v-model.trim="form.evidencePhoto"
                  color="primary"
                  outlined
                  dense
                  hint="Attachment file types: .jpg, .jpeg, .png,"
                  type="file"
                  multiple
                  :loading="isFileUploading"
                  @change="handleImagesUploading"
                  v-if="accessType == 'readOnly' ? false : true"
                  class="formField"
                />
              </template>
            </div>
            <template v-if="accessType === 'CREATE'">
              <div
                v-if="fileList?.length"
                class="bordered imagesSection q-mt-lg q-card--bordered q-pa-sm rounded-borders q-mb-md"
              >
                <div class="section-heading">
                  <span style="font-weight: 900">Attachments:</span>
                </div>
                <q-chip
                  style="cursor: pointer"
                  v-for="(file, i) in fileList"
                  :key="i"
                  square
                >
                  <q-avatar
                    @click="deleteHandle(i)"
                    :icon="accessType == 'readOnly' ? 'link' : 'delete'"
                    color="primary"
                    text-color="white"
                  />
                  <q-item-label dense @click="viewAttechment(file)">
                    {{
                      file.fileObj?.fileName ||
                      file.fileObj?.name ||
                      file.fileObj?.evidencePhotoRefName
                    }}
                  </q-item-label>
                </q-chip>
              </div>
            </template>

            <div class="row q-pt-md">
              <q-input
                v-model.trim="form.productDescription"
                :disable="accessType === 'readOnly'"
                outlined
                dense
                type="textarea"
                class="col-12"
                label="Product Description *"
                :rules="[required]"
              />
            </div>
          </section>

          <section v-if="activeStep === 1" class="form-card review-card">
            <div class="section-heading">
              <span class="section-icon"
                ><q-icon size="md" name="fact_check"
              /></span>
              <div>
                <h2>
                  {{
                    accessType === "readOnly"
                      ? "Project Information"
                      : "Review Project"
                  }}
                </h2>
                <p v-if="accessType !== 'readOnly'">
                  Confirm the information before submitting it.
                </p>
              </div>
            </div>
            <div class="review-summary">
              <div v-for="(item, i) in summary" :key="i" class="review-item">
                <template v-if="item.label == 'Update Date'">
                  <span>{{ item.label }}</span
                  ><strong>{{
                    $moment(item.value).format("DD/MM/YYYY") || "--"
                  }}</strong>
                </template>
                <template v-else-if="item.label == 'Date of First Visit'">
                  <span>{{ item.label }}</span
                  ><strong>{{
                    $moment(item.value).format("DD/MM/YYYY") || "--"
                  }}</strong>
                </template>
                <template v-else-if="item.label == 'Qoute submission Date'">
                  <span>{{ item.label }}</span
                  ><strong>{{
                    $moment(item.value).format("DD/MM/YYYY") || "--"
                  }}</strong>
                </template>
                <template v-else-if="item.label === 'Total Quote Value'">
                  <span>{{ item.label }}</span
                  ><strong>{{ formattedTotalQuoteValue || "--" }}</strong>
                </template>
                <template v-else-if="item.label === 'Product Description'">
                  <span>{{ item.label }}</span>
                  <div>
                    <q-input
                      v-model.trim="item.value"
                      :readonly="true"
                      outlined
                      dense
                      autogrow
                    />
                  </div>
                </template>
                <template v-else>
                  <span>{{ item.label }}</span
                  ><strong>{{ item.value || "--" }}</strong>
                </template>
              </div>
            </div>
            <div
              v-if="accessType === 'CREATE'"
              class="bordered imagesSection q-mt-lg q-card--bordered q-pa-sm rounded-borders"
            >
              <div class="section-heading">
                <span style="font-weight: 900">Attachments:</span>
              </div>
              <template v-if="fileList?.length">
                <q-chip v-for="(file, i) in fileList" :key="i" square>
                  <q-avatar icon="link" color="primary" text-color="white" />
                  <q-item-label
                    style="cursor: pointer"
                    dense
                    @click="viewAttechment(file)"
                  >
                    {{
                      file.fileObj?.fileName ||
                      file.fileObj?.name ||
                      file.fileObj?.evidencePhotoRefName
                    }}
                  </q-item-label>
                </q-chip>
              </template>
              <span v-else>No Data Found</span>
            </div>

            <!-- <q-card-section class="q-mt-lg q-pa-none" style="min-height: 150px; max-width: 100%; display: flex;" :style="{ flexDirection: $q.screen.lt.md ? 'column' : 'row' }">
                        <div class="section-heading">
                            <span style="font-weight: 900">Product Qouted:</span>
                        </div>
                        <q-chip
                            class=""
                            v-for="(code, i) in itemsCodesList"
                            :key="i"
                            :removable="accessType != 'readOnly'"
                            dense
                            @remove="itemsCodesList.splice(i, 1)"
                        >
                            <span class="code-class">{{ code }}</span>
                        </q-chip>
                    </q-card-section> -->
            <q-card-section
              v-if="accessType === 'CREATE'"
              class="q-mt-lg q-pa-none quoted-products-section"
              :style="{ flexDirection: $q.screen.lt.md ? 'column' : 'column' }"
            >
              <div class="section-heading">
                <span style="font-weight: 900">Product Qouted:</span>
              </div>

              <div class="chips-wrapper">
                <q-chip
                  v-for="(code, i) in itemsCodesList"
                  :key="i"
                  :removable="accessType != 'readOnly'"
                  dense
                  class="code-chip"
                  @remove="itemsCodesList.splice(i, 1)"
                >
                  <span class="code-class">{{ code }}</span>
                </q-chip>
              </div>
            </q-card-section>
            <q-banner
              v-if="accessType !== 'readOnly'"
              rounded
              class="review-note"
              ><template v-slot:avatar
                ><q-icon name="info" color="primary" /></template
              >Once submitted, this project becomes available for follow-up and
              reporting.</q-banner
            >
          </section>
          <footer
            :class="$q.screen.lt.sm ? 'form-actions-mobile' : 'form-actions'"
          >
            <q-btn
              v-if="activeStep > 0 && accessType != 'readOnly'"
              flat
              no-caps
              label="Back"
              icon="arrow_back"
              @click="backStep"
            /><q-space />
            <div v-if="accessType != 'readOnly'">
              <q-btn
                v-if="activeStep < 1"
                unelevated
                no-caps
                label="Continue"
                icon-right="arrow_forward"
                :class="'primary-button'"
                :disable="isSaving"
                @click="nextStep"
              /><q-btn
                v-else
                unelevated
                :disable="isSaving"
                :loading="isSaving"
                no-caps
                label="Submit project"
                icon-right="check_circle"
                :class="'primary-button'"
                :style="{ width: $q.screen.lt.sm ? '100% !important' : '' }"
                @click="Save"
              />
            </div>
          </footer>
        </q-form>

        <project-info
          @files-attachment="Save"
          @save-product="Save"
          ref="projectUpdate"
          v-if="accessType == 'update' || accessType == 'readOnly'"
          :products="products"
          :userAccesstypes="userAccesstypes || {}"
          :isItemSaving="isSaving"
        />
        <edit-count-down
          :created-when="form.createdWhen"
          :server-date="form.serverDate"
          :limit-hours="24"
          @expired="handleExpire"
          v-if="accessType != 'CREATE'"
        />
      </div>
      <access-not-allowed v-else />
    </section>

    <!-- <location-picker :isShowLocPick="isShowLocPick" ref="locDialogRef" v-model="selectedLocation" @selected="locationSelected" /> -->
    <drawer ref="refDrawer" />
  </main>
</template>

<script>
import apis from "@/utilities";
// import LocationPicker from '@/views/components/LocationPicker.vue';
import Drawer from "../layout/drawer.vue";
import axios from "axios";
import appHeader from "../components/header.vue";
import editCountDown from "../components/editCountDown.vue";
import projectInfo from "./projectInfo.vue";
import privileges from "@/mixins/privileges";
const emptyForm = () => ({
  dealerName: "",
  updateDate: new Date().toISOString().slice(0, 10),
  dateOfFirstVisit: null,
  qouteSubmissionDate: null,
  projectName: "",
  location: "",
  projectCity: "",
  projectStage: "",
  dealerRepName: "",
  totalQuoteValue: "",
  productQoute: "",
  productDescription: "",
  evidencePhoto: "",
  createdWhen: "",
  serverDate: "",
  projectId: 0,
  srNo: 0,
  id: 0,
});
export default {
  name: "VisitedForm",
  mixins: [privileges],
  components: {
    // LocationPicker,
    drawer: Drawer,
    appHeader,
    editCountDown,
    projectInfo,
  },
  data() {
    return {
      activeStep: 0,
      steps: ["Project details", "Review"],
      form: emptyForm(),
      visitPurposes: [],
      accountTypes: [],
      selectedLocation: {
        lat: null,
        lng: null,
        address: "",
      },
      isShowLocPick: false,
      cities: [],
      products: [],
      projectStages: [],
      fileList: [],
      isFileUploading: false,
      isSaving: false,
      location: {},
      mapUrl: null,
      projectCities: [],
      accessType: "",
      isloading: false,
      keySelect: 0,
      dealers: [],
      itemsCodesList: [],
      remainingTime: "", // e.g. "09:58:32"
      remainingSeconds: 0,
      editExpired: false,
      timerInterval: null,
    };
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  },
  computed: {
    summary() {
      return [
        { label: "Dealer Name", value: this.form.dealerName },
        { label: "Project Name", value: this.form.projectName },
        { label: "Location", value: this.form.location },
        { label: "Project City", value: this.form.projectCity },
        { label: "Project Stage", value: this.form.projectStage },
        { label: "Update Date", value: this.form.updateDate },
        { label: "Dealer Rep. Name", value: this.form.dealerRepName },
        { label: "Date of First Visit", value: this.form.dateOfFirstVisit },
        {
          label: "Qoute submission Date",
          value: this.form.qouteSubmissionDate,
        },
        { label: "Total Quote Value", value: this.form.totalQuoteValue },
        { label: "Product Description", value: this.form.productDescription },
      ];
    },
    url() {
      return this.$store.getters.url;
    },
    formattedTotalQuoteValue: {
      get() {
        if (
          this.form.totalQuoteValue === null ||
          this.form.totalQuoteValue === ""
        ) {
          return "";
        }

        return Number(this.form.totalQuoteValue).toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
      },

      set(value) {
        // commas remove karke actual numeric value save hogi
        this.form.totalQuoteValue = value
          .replace(/,/g, "")
          .replace(/[^\d.]/g, "");
      },
    },
  },
  mounted() {
    this.activeStep = 0;
    const { key } = this.$route.params;
    let paramData = key.split("_");
    this.accessType = paramData[paramData.length - 1];
    console.log("accessType: ", this.accessType);
    this.cacheUserPrivileges();
    const draftId = this.$route.query.draft;

    if (!draftId) return;
    try {
      const drafts = JSON.parse(
        localStorage.getItem("sera-visit-drafts") || "[]"
      );
      const draft = drafts.find((item) => item.id === draftId);
      if (draft) this.form = { ...this.form, ...draft.data };
    } catch (error) {
      console.log("error: ", error);
    }
  },
  methods: {
    callInitialFunctions() {
      Promise.all([
        this.getCity(),
        // this.GetZone(),
        // this.GetRegion(),
        this.GetProjectStages(),
        // this.GetAccountType(),
        this.GetAccounts(),
        this.GetItems(),
      ]).then(() => {
        if (this.accessType != "CREATE") {
          const { key } = this.$route.params;
          let paramData = key.split("_");
          this.getVisistFormById(paramData[0]);
          this.form.projectId = paramData[0];
        }
      });
    },

    handleExpire() {
      console.log("handleExpire: ");
      this.form.editLocked = true;
      this.accessType = "readOnly";
      this.activeStep = 1;
    },
    startEditCountdown(visit) {
      console.log("visit: ", visit);
      // purana interval clear kar do agar chal raha ho
      if (this.timerInterval) clearInterval(this.timerInterval);

      const serverDate = visit.serverDate;
      const submittedAt = new Date(visit.createdWhen).getTime();
      const serverNow = new Date(serverDate).getTime();

      // server aur local clock ka farq nikal ke lock kar lo,
      // taake setInterval local clock se hi aage chalta rahy
      const offset = serverNow - Date.now();

      const LIMIT_MS = 24 * 60 * 60 * 1000; // 24 hours

      const tick = () => {
        const now = Date.now() + offset;
        const remainingMs = LIMIT_MS - (now - submittedAt);

        if (remainingMs <= 0) {
          this.remainingSeconds = 0;
          this.remainingTime = "00:00:00";
          this.editExpired = true;
          clearInterval(this.timerInterval);
          return;
        }

        this.editExpired = false;
        this.remainingSeconds = Math.floor(remainingMs / 1000);

        const hrs = Math.floor(remainingMs / (1000 * 60 * 60));
        const mins = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((remainingMs % (1000 * 60)) / 1000);

        this.remainingTime = [hrs, mins, secs]
          .map((v) => String(v).padStart(2, "0"))
          .join(":");
      };

      tick(); // turant ek dafa chala do, warna 1 sec wait karna paray ga
      this.timerInterval = setInterval(tick, 1000);
    },
    handleSelect(model, value) {
      this.form[model] = value;

      if (model === "accountCode") {
        // if (!value) return;

        const findAcc = this.accounsts.find(
          (e) => e.accountId === value?.split("-")[0]
        );
        const findAccType = this.accountTypes.find(
          (e) => e.accountTypeId === findAcc?.accountTypeId
        );
        this.form.accountType = findAccType?.accountTypeName;
        this.form.contactPerson = findAcc?.contactPerson;
        this.form.mobile = findAcc?.phone;
        this.form.dealerName = findAcc?.accountName || "";
      } else if (model == "productQoute") {
        let code = null;
        if (value) code = value?.split("-")[0];
        if (code) this.itemsCodesList.push(code);
        this.form.productQoute = "";
        if (this.$refs.productQoute) {
          this.$refs.productQoute.setValue("");
        }
        this.form = { ...this.form };
      }
    },
    async GetAccounts() {
      try {
        const reponse = await axios.get(
          `${this.url}/${apis.GetProjectDealers}`
        );
        this.dealers = reponse.data.data ?? [];
        if (this.dealers.length == 1) {
          this.form.dealerName = this.dealers[0].name;
        }
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    locationSelected(location) {
      if (!location.lat || !location.lng) return;

      this.form.gpsLocation = location.address;
      this.location = location;
      this.mapUrl = `https://www.google.com/maps?q=${location.lat},${location.lng}&output=embed`;

      /*
        Example:

        {
          lat: 24.860734,
          lng: 67.001136,
          address: "Karachi, Sindh, Pakistan..."
        }
      */

      // API ko send kar sakte ho
      // this.form.latitude = location.lat;
      // this.form.longitude = location.lng;
      // this.form.address = location.address;
    },
    handleShowDialog() {
      if (this.$refs.locDialogRef) {
        this.$refs.locDialogRef?.showDialog();
      }
    },
    logout() {
      sessionStorage.setItem("token", null);
      this.$store.commit("logOutHandler");
      // this.$router.push('/login');
    },
    required(value) {
      return !!value || "This field is required";
    },
    async nextStep() {
      const valid = await this.$refs.projectForm.validate();
      if (valid) this.activeStep = Math.min(this.activeStep + 1, 1);
    },
    saveDraft() {
      const draftId = this.$route.query.draft || `draft-${Date.now()}`;
      const drafts = JSON.parse(
        localStorage.getItem("sera-visit-drafts") || "[]"
      );
      const draft = {
        id: draftId,
        data: { ...this.form },
        updatedAt: new Date().toISOString(),
      };
      const index = drafts.findIndex((item) => item.id === draftId);
      if (index >= 0) drafts.splice(index, 1, draft);
      else drafts.unshift(draft);
      localStorage.setItem("sera-visit-drafts", JSON.stringify(drafts));
      if (!this.$route.query.draft)
        this.$router.replace({
          path: "/visit-form",
          query: { draft: draftId },
        });
      this.$q.notify({
        type: "positive",
        message: "Visit saved as draft.",
        position: "top",
      });
    },
    async submitVisit() {
      const valid = await this.$refs.projectForm.validate();
      if (!valid) {
        this.activeStep = 0;
        return;
      }
      const draftId = this.$route.query.draft;
      if (draftId) {
        const drafts = JSON.parse(
          localStorage.getItem("sera-visit-drafts") || "[]"
        ).filter((item) => item.id !== draftId);
        localStorage.setItem("sera-visit-drafts", JSON.stringify(drafts));
      }
      this.$q.notify({
        type: "positive",
        message: "Visit submitted successfully.",
        position: "top",
      });
      this.form = emptyForm();
      this.$router.replace("/visit-form");
      this.activeStep = 0;
      this.$refs.projectForm.resetValidation();
    },

    async getCity() {
      try {
        const response = await axios.get(`${this.url}/${apis.GetCity}`);
        this.projectCities = response.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetZone() {
      try {
        const response = await axios.get(`${this.url}/${apis.GetZone}`);
        this.zones = response.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetRegion() {
      try {
        const response = await axios.get(`${this.url}/${apis.GetRegion}`);
        this.regions = response.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetProjectStages() {
      try {
        const response = await axios.get(
          `${this.url}/${apis.GetProjectStages}`
        );
        this.projectStages = response.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetAccountType() {
      try {
        const reponse = await axios.get(`${this.url}/${apis.GetAccountType}`);
        this.accountTypes = reponse.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetSalesAccountManagers() {
      try {
        const reponse = await axios.get(
          `${this.url}/${apis.GetSalesAccountManagers}`
        );
        this.samNames = reponse.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async GetItems() {
      try {
        const reponse = await axios.get(`${this.url}/${apis.GetItems}`);
        this.products = reponse.data.data ?? [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
    },
    async Save(data, type) {
      console.log("data: ", data);
      const { key } = this.$route.params;
      let paramData = key.split("_");
      // const city = this.projectCities.find((e) => e.cityName == this.form.projectCity)?.cityId;
      // const projectStages = this.projectStages.find((e) => e.stageName == this.form.projectStage)?.stageId;

      const itemsCode = type == "product" ? data?.map((e) => e.sku) : [];
      const itemsCodeInitial = this.accessType == "CREATE" ? this.itemsCodesList : this.itemsCodesList?.map((e) => e.split('-')?.[0]);
      console.log("itemsCode: ", itemsCode);
      const dealer = this.dealers.find((e) => e.name == this.form.dealerName);
      if(!dealer) return this.warningNotification('Dealer Not Found!')
      console.log('this.form: ', this.form);
      console.log('dealer: ', dealer);
      let fileList =
        type == "files" ? [...this.fileList, ...data] : this.fileList;
      let itemList = type == "product" ? [...itemsCode] : itemsCodeInitial;
      console.log("this.itemsCodesList: ", itemsCodeInitial);
      console.log("itemList: ", itemList);
      const files = fileList.map((f) => {
        return {
          attachment: f?.dataUrl || null,
          contentType: f?.AttachmentType || null,
          fileName: f?.fileObj?.name || f.fileObj.fileName,
        };
      });
      const items = itemList?.map((a) => {
        // let code = this.products.find((w) => w.skuCode === a)?.itemCode;
        return {
          skuCode: type == "files" ? a?.split("-")[0] : a || null,
          productId: this.accessType != "CREATE" ? paramData[0] : 0 || 0,
        };
      });
      const payload = {
        id: this.accessType != "CREATE" ? this.form.id || 0 : 0,
        projectName: this.form.projectName,
        dealerId: dealer?.id,
        dealerCity: dealer.city,
        Location: this.form.location,
        ProjectCity: this.form.projectCity,
        ProjectStage: this.form.projectStage,
        updateDate: this.form.updateDate,
        DealerPersonName: this.form.dealerRepName,
        dateOfFirstVisit: this.form.dateOfFirstVisit || null,
        quoteSubmissionDate: this.form.qouteSubmissionDate,
        totalQuoteValue: this.form.totalQuoteValue || 0,
        ProjectDescription: this.form.productDescription,
        createdBy: "",
        evidencePhotoRefs: files,
        projectProduct: items,
        srNo: this.form.srNo,
      };

      this.isSaving = true;

      try {
        const response = await axios.post(
          `${this.url}/${apis.SaveProject}`,
          payload
        );
        if (response.data.success && response.data.validationState == 0) {
          this.accessType = "readOnly";

          this.activeStep = 0;
          if (type) {
            this.getVisistFormById(paramData[0]);
          } else {
            this.form = emptyForm();
            this.$router.push("/project-list");
          }
        }
        this.globalNotification(
          response.data.message,
          response.data.validationState
        );
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }

      this.isSaving = false;
    },

    async getVisistFormById(id) {
      this.activeStep = this.accessType == "update" ? 0 : 1;
      this.isloading = true;
      this.itemsCodesList = []
      try {
        const response = await axios.get(
          `${this.url}/${apis.GetProject}?srNo=${id}`
        );
        if (response.data.success) {
          const { data } = response.data;
          if (!data) return;
          const dealer = this.dealers.find((e) => e.id === data.dealerId);

          // const stage = this.projectStages.find((e) => e.stageId === data.stageId);
          // const city = this.projectCities.find((e) => e.cityId === data.city);
          const dateFormat = (date) =>
            date ? this.$moment(date).format("YYYY-MM-DD") : null;
          this.form = {
            projectId: data.id,
            visitDate:
              this.accessType === "update"
                ? this.$moment(data.visitDate)?.format("YYYY-MM-DD")
                : this.formatDate(data.visitDate),
            dealerName: dealer?.name || "",
            projectName: data.projectName,
            location: data.location,
            projectCity: data?.projectCity,
            projectStage: data.projectStage,
            updateDate: data.updateDate ? dateFormat(data.updateDate) : "",
            dealerRepName: data.dealerPersonName,
            dateOfFirstVisit: data.dateOfFirstVisit
              ? dateFormat(data.dateOfFirstVisit)
              : "",
            qouteSubmissionDate: data.quoteSubmissionDate
              ? dateFormat(data.quoteSubmissionDate)
              : "",
            totalQuoteValue: data.totalQuoteValue ? data.totalQuoteValue : 0,
            productDescription: data.projectDescription,
            createdWhen: data.createdAt,
            serverDate: data.serverDate,
            srNo: data.srNo || 0,
            id: data.id || 0,
          };

          if (data?.projectProduct?.length) {
            data?.projectProduct?.map((d) => {
              const item = this.products.find((a) => a.skuCode === d.skuCode);
              // if (this.accessType == 'readOnly' && item) {
              this.itemsCodesList.push(
                `${item.skuCode}-${item.prodDescription}`
              );
              // } else this.itemsCodesList.push(item.skuCode);
            });
          }
                console.log('this.itemsCodesList: ', this.itemsCodesList);
          // this.locationSelected(this.selectedLocation);
          this.fileList = data.evidencePhotoRefs.map((e) => {
            return {
              fileObj: e,
              dataUrl: e.attachment,
              AttachmentType: e.contentType,
            };
          });

          if (this.$refs.projectUpdate) {
            this.$refs.projectUpdate.setProjectId(
              this.form,
              this.fileList,
              this.itemsCodesList
            );
            console.log("this.itemsCodesList: ", this.itemsCodesList);
          }
        } else {
          this.accessType = "readOnly";
          this.warningNotification(response.data.message);
        }
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        const newError = err.response || err;
        console.error(newError);
      }
      this.keySelect += 1;

      this.isloading = false;
    },
    viewAttechment(att) {
      let string = `data:${att.AttachmentType};base64,${att.dataUrl}`;

      var iframe =
        "<iframe width='100%' height='100%' src='" + string + "'></iframe>";
      var x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();
    },
    formatDate(date) {
      if (!date) return "N/A";
      const value = String(date).substring(0, 10);
      const parts = value.split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },

    deleteHandle(i) {
      if (this.accessType == "readOnly") return;

      this.fileList.splice(i, 1);
    },

    async handleImagesUploading() {
      if (this.form.evidencePhoto?.length > 0) {
        this.isFileUploading = true;

        let fileList = [];

        for (let fileObj of this.form.evidencePhoto) {
          try {
            const compressedBase64 = await this.readFileAsBase64(
              fileObj,
              15000
            );
            const resizedImage = compressedBase64
              .replace("data:", "")
              .replace(/^.+,/, "");
            if (!resizedImage) throw new Error("Empty compression result");
            fileList.push({
              fileObj,
              dataUrl: resizedImage,
              AttachmentType: fileObj.type,
            });
          } catch (err) {
            this.$store.dispatch("triggerUnauthorizedError", err);
            const newError = err.response || err;
            console.error(newError);
          }
        }
        this.fileList =
          this.fileList.length > 0 ? [...this.fileList, ...fileList] : fileList;
           this.isFileUploading = false;
      }
    },
    readFileAsBase64(file, ms = 15000) {
      // return new Promise((resolve, reject) => {
      //     const reader = new FileReader();
      //     reader.onload = (e) => {
      //         resolve(e.target.result.replace('data:', '').replace(/^.+,/, ''));
      //     };
      //     reader.onerror = reject;
      //     reader.readAsDataURL(file);
      // });
      return Promise.race([
        this.compressImage(file),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Compression timed out")), ms)
        ),
      ]);
    },
    async compressImage(file) {
      return new Promise((resolve, reject) => {
        const maxSize = 800;
        const reader = new FileReader();

        reader.onerror = (err) => {
          console.error("FileReader failed", err);
          reject(new Error("Failed to read file: " + file.name));
        };

        reader.onload = (event) => {
          const img = new Image();

          img.onerror = (err) => {
            console.error("Image load failed for", file.name, file.type, err);
            reject(
              new Error(`Unsupported or corrupt image format: ${file.name}`)
            );
          };

          img.onload = () => {
            try {
              const width = img.width;
              const height = img.height;
              let newWidth = width;
              let newHeight = height;

              if (width > maxSize || height > maxSize) {
                if (width > height) {
                  newWidth = maxSize;
                  newHeight = Math.floor((height / width) * maxSize);
                } else {
                  newHeight = maxSize;
                  newWidth = Math.floor((width / height) * maxSize);
                }
              }

              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = newWidth;
              canvas.height = newHeight;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);

              const compressedBase64 = canvas.toDataURL("image/jpeg", 0.8);
              resolve(compressedBase64);
            } catch (error) {
              console.error("Canvas processing failed", error);
              reject(error);
            }
          };

          img.src = event.target.result;
        };

        reader.readAsDataURL(file);
      });
    },
    showDrawer() {
      if (this.$refs.refDrawer) {
        this.$refs.refDrawer.toggleDrawer();
      }
    },
    backStep() {
      this.activeStep = Math.max(this.activeStep - 1, 0);
    },
    // getCurrentLocation() {
    //     if (!navigator.geolocation) {
    //         this.$q.notify({
    //             type: 'negative',
    //             message: 'Location is not supported by this browser.',
    //         });
    //         return;
    //     }

    //     navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //             const latitude = position.coords.latitude;
    //             const longitude = position.coords.longitude;

    //             this.latitude = latitude;
    //             this.longitude = longitude;
    //             this.gpsLocation = `${latitude},${longitude}`;

    //             console.log('Location:', this.gpsLocation);
    //         },

    //         (error) => {
    //             console.log('Location error:', error);

    //             switch (error.code) {
    //                 case error.PERMISSION_DENIED:
    //                     this.$q.notify({
    //                         type: 'warning',
    //                         message: 'Please allow location permission for this site.',
    //                     });
    //                     break;

    //                 case error.POSITION_UNAVAILABLE:
    //                     this.$q.notify({
    //                         type: 'warning',
    //                         message: 'Location information is unavailable.',
    //                     });
    //                     break;

    //                 case error.TIMEOUT:
    //                     this.$q.notify({
    //                         type: 'warning',
    //                         message: 'Location request timed out.',
    //                     });
    //                     break;
    //             }
    //         },

    //         {
    //             enableHighAccuracy: true,
    //             timeout: 15000,
    //             maximumAge: 0,
    //         }
    //     );
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/quasar.scss";
.visit-page {
  min-height: 100vh;
  padding: 32px 16px;
  // background: #f2f7f8;
  color: $primary;
  text-align: left;
}
.visit-shell {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
}
.visit-header {
  min-height: 162px;
  padding: 30px 34px;
  display: flex;
  align-items: flex-start;
  gap: 18px;
  color: $primary;
  background: #fff;
  border-radius: 20px 20px 0 0;
  margin-bottom: 2px;
  box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18) !important;
  position: relative;
}
.brand-mark,
.section-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 12px;
}
.brand-mark {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.16);
}
.eyebrow {
  margin: 2px 0 5px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  opacity: 0.75;
}
h1 {
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}
.header-copy {
  margin: 7px 0 0;
  font-size: 14px;
  opacity: 0.85;
}
.header-status {
  margin-left: auto;
  padding: 8px 11px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 18px;
  font-size: 12px;
  white-space: nowrap;
}
.header-actions {
  position: absolute;
  top: 22px;
  right: 22px;
  margin: 0;
  display: flex;
  gap: 8px;
}
.drafts-link,
.logout-link {
  color: $primary;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 18px;
}
.progress-steps {
  padding: 18px 34px;
  display: flex;
  justify-content: space-around;
  background: #fff;
  border-bottom: 1px solid #e5edef;
}
.progress-step {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #91a1a5;
  font-weight: 600;
  font-size: 18px;
}
.progress-step span {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #edf2f3;
  // margin-left: 10px;
  font-size: 18px;
}
.progress-step.active {
  color: $primary;
}
.progress-step.active span {
  color: #fff;
  background: $primary;
}
.progress-step.current small {
  font-weight: 700;
}
.form-card {
  padding: 32px 34px 28px;
  background: #fff;
}
.section-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}
.section-icon {
  width: 38px;
  height: 38px;
  color: $primary;
  background: #e7f2f4;
}
.section-heading h2 {
  margin: 0;
  font-size: 19px;
  color: $primary;
}
.section-heading p {
  margin: 3px 0 0;
  font-size: 13px;
  color: #73858a;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 18px;
}
.form-grid :deep(.q-field__bottom) {
  padding-top: 4px;
  color: #778b90;
}
.form-grid :deep(.q-field--outlined .q-field__control:before) {
  border-color: #cbd9dc;
}
.form-grid :deep(.q-field--focused .q-field__control:after) {
  border-color: $primary;
}
.form-grid :deep(.q-field__label) {
  color: #778b90;
}
.form-grid :deep(.q-field__native) {
  color: rgba(0, 0, 0, 0.87);
}
.review-card {
  min-height: 390px;
}
.review-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #e0e9eb;
  border-radius: 12px;
  overflow: hidden;
}
.review-item {
  min-height: 70px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-bottom: 1px solid #e8eff0;
}
.review-item:nth-last-child(-n + 2) {
  border-bottom: 0;
}
.review-item:nth-child(odd) {
  border-right: 1px solid #e8eff0;
}
.review-item span {
  color: #789096;
  font-size: 12px;
}
.review-item strong {
  color: $primary;
  font-size: 14px;
  font-weight: 600;
}
.review-note {
  margin-top: 22px;
  color: #50676d;
  background: #f0f7f8;
  font-size: 13px;
}
.form-actions {
  padding: 18px 34px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border-top: 1px solid #e5edef;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}
.form-actions-mobile {
  padding: 18px 34px;
  display: flex;
  align-items: center;
  // justify-items: end;
  // width:100% !important;
  gap: 8px;
  background: #fff;
  border-top: 1px solid #e5edef;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}
.draft-button {
  color: $primary;
}
.primary-button {
  color: #fff;
  background: $primary-gradient;
  border-radius: 8px;
}

.primary-button-mobile {
  width: 100% !important;
  color: #fff;
  background: $primary-gradient;
  border-radius: 8px;
  padding: 5px;
  font-size: 18px;
}

@media (max-width: 800px) {
  .visit-page {
    padding: 0;
  }
  .visit-shell {
    max-width: 100%;
  }
  .visit-header {
    min-height: 176px;
    padding: 24px 18px;
    border-radius: 0;
    flex-wrap: wrap;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
    position: relative;
  }
  .header-status {
    margin-left: 66px;
    margin-top: -27px;
  }
  .visit-header {
    position: relative;
    padding-top: 70px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
  }

  .visit-header h1 {
    font-size: 18px;
  }
  .header-actions {
    // position: static;
    // margin-left: auto;
    // top: 22px;
    // right: 22px;
    position: absolute;
    top: 22px;
    right: 22px;
    margin: 0;
    display: flex;
    gap: 8px;
  }
  .fts-link,
  .logout-link {
    font-size: 11px;
  }
  .progress-steps {
    padding: 11px 13px;
    justify-content: space-between;
  }
  .progress-step {
    flex-direction: column;
    gap: 4px;
    align-items: center;
    font-size: 13px;
  }
  .progress-step small {
    font-size: 11px;
  }
  .progress-step span {
    width: 20px;
    height: 20px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #edf2f3;
    // margin-left: 10px;
    font-size: 14px;
  }
  .form-card {
    padding: 25px 18px;
  }
  .form-grid,
  .review-summary {
    grid-template-columns: 1fr;
  }
  .review-item:nth-child(odd) {
    border-right: 0;
  }
  .review-item:nth-last-child(2) {
    border-bottom: 1px solid #e8eff0;
  }

  .review-item span {
    color: #789096;
    font-size: 15px;
  }
  .review-item strong {
    color: $primary;
    font-size: 18px;
    font-weight: 600;
  }
  .form-actions-mobile {
    padding: 16px 18px;
    width: 100%;
    display: flex;
    justify-content: end;
    border-radius: 0;
  }
  .draft-button {
    padding: 5px;
    font-size: 0;
  }
  .draft-button :deep(.q-btn__content) {
    font-size: 18px;
  }
  .formField {
    min-height: 60px;
  }

  .formField :deep(.q-field__control) {
    height: 60px;
    min-height: 60px;
  }

  .formField :deep(.q-field__native) {
    min-height: 60px;
  }
  .formField .q-item {
    min-height: 80px;
  }

  .formFieldMarket {
    min-height: 60px;
  }

  .gps-field {
    flex-direction: column;
  }
  .gps-field .gps-map-btn {
    width: 100%;
  }
  .gps-field .gps-input {
    width: 100% !important;
  }
  .section-icon {
    width: 42px;
    height: 42px;
    color: $primary;
    background: #e7f2f4;
  }

  .heading-section {
    flex: 1;
  }
}

@media (min-width: 1024px) {
  .visit-shell {
    max-width: 100%;
  }
}

@media (min-width: 1201px) {
  .visit-shell {
    max-width: 80vw;
  }
}

.gps-field {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.gps-input {
  flex: 1;
  min-width: 0;
}

.gps-map-btn {
  height: 40px;
  margin-top: 0;
  flex-shrink: 0;
}
.brand-logo-sera {
  height: 16px;
  margin-bottom: 10px;
}

.sub-heading {
  color: $magenta !important;
}
.full-width {
  grid-column: 1 / -1 !important;
}
.code-class {
  color: $primary;
}
.quoted-products-section {
  min-height: 150px;
  max-width: 100%;
  display: flex;
}

.chips-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
  min-width: 0; /* flex child ko shrink karne deta hai, warna overflow hota hai */
}

.code-chip {
  max-width: 100%;
  height: auto;
  min-height: 28px;

  :deep(.q-chip__content) {
    white-space: normal;
    word-break: break-word;
    line-height: 1.3;
    padding: 4px 0;
  }
}

.code-class {
  white-space: normal;
  word-break: break-word;
}

/* ============ MOBILE ============ */
@media (max-width: 599px) {
  .chips-wrapper {
    width: 100%;
  }

  .code-chip {
    max-width: 100%;
    width: fit-content;
  }
}
</style>
